import { getRoomOption } from "../../features/base/conference";
import { CAMERA_FACING_MODE } from "../../features/base/media";
import { RECORDING_TYPE, setRecordingEnabled } from "../../features/recording";
import Record from "./Record";

class ScreenRecord {
    constructor() {
        this.audioContext = null;
        this.storage = {
            AudioContext: null,
            AudioContextConstructor: null
        };

        this.stream = new Map();
        this.record = new Record();
    }

    init(handler) {
        var audioContext = window.AudioContext;
        if (typeof audioContext === undefined) {
            if (typeof window.webkitAudioContext !== undefined) {
                /*global AudioContext:true */
                audioContext = window.webkitAudioContext;
            }
    
            if (typeof window.mozAudioContext !== undefined) {
                /*global AudioContext:true */
                audioContext = window.mozAudioContext;
            }
        }

        this.audioContext = audioContext;

        this.storage = {
            AudioContext: null,
            AudioContextConstructor: null
        };
        if (typeof audioContext !== undefined) {
            this.storage.AudioContext = audioContext;
        } else if (typeof window.webkitAudioContext !== undefined) {
            this.storage.AudioContext = window.webkitAudioContext;
        }

        this.record.init(handler);
        this.handler = handler;
    }

    loadAudioStraem(audioTrack) {
        if (!this.storage.AudioContextConstructor) {
            this.storage.AudioContextConstructor = new this.storage.AudioContext();
        }

        this.audioContext = this.storage.AudioContextConstructor;
        this.audioSources = [];
        
        this.gainNode = this.audioContext.createGain();
        this.gainNode.connect(this.audioContext.destination);
        this.gainNode.gain.value = 0;

        this.audioDestination = this.audioContext.createMediaStreamDestination();

        audioTrack.forEach(track => {
            const stream = track.stream;
            
            var audioSource = this.audioContext.createMediaStreamSource(stream);
            audioSource.connect(this.gainNode);

            this.audioSources.push(audioSource);

            this.stream.set(stream.id, track);
        });
    }
    
    getMixedAudioStream() {
        this.audioSources.forEach((audioSource) => {
            audioSource.connect(this.audioDestination);
        });

        return this.audioDestination.stream;
    }

    connectAudio(audioTracks) {
        if (this.record && this.record.isRecording()) {
            let list = new Array();
            if (this.stream.size > audioTracks.size) {
                this.stream.forEach((t, streamId) => {
                    if (audioTracks.has(streamId)) return;
                    list.push(streamId);
                });

                list.map(streamId => {
                    const idx = this.audioSources.findIndex((source, id) => id == streamId);
                    if (idx > -1) {
                        this.audioSources[idx].disconnect();
                        this.audioSources.splice(idx, 1);
                    }
                });                
            } else {
                audioTracks.forEach((t, streamId) => {
                    if (this.stream.has(streamId)) return;
                    list.push(t);
                });

                list.map(t => {
                    const stream = t.stream;
                    var audioSource = this.audioContext.createMediaStreamSource(stream);
                    audioSource.connect(this.gainNode);
            
                    this.audioSources.push(audioSource);
                    audioSource.connect(this.audioDestination);
                });  
            }
        }
    }

    // 녹화 시작 
    async startRecord() {
        let gdmStream = this.gdmStream;
        try {
            gdmStream = await navigator.mediaDevices.getDisplayMedia({ video: {
                height: 1280,
                maxFps: 10,
                facingMode: CAMERA_FACING_MODE.USER
            }, audio: false });
    
            var mixedAudioStream = this.getMixedAudioStream();
            var mixTracks = mixedAudioStream.getTracks().concat(gdmStream.getVideoTracks());
            var resultStream = new MediaStream(mixTracks);
    
            if (this.recordType === RECORDING_TYPE.SERVER) {
                this.createWebSocket();
            }

            this.record.start(resultStream);

            gdmStream && gdmStream.addEventListener('inactive', () => this.record.stop() );


            this.gdmStream = gdmStream;
        } catch (e) { 
            this.handler.stop();
            this.record.stop();
        }        
    }

    stopRecord() {
        this.gdmStream && this.gdmStream.getTracks().forEach(track => track.stop());
        this.gdmStream = null;
    }

    getSaveFile(filename) {
        this.record.getSaveFile(filename);
    }

    // 녹화 가능 브라우저 
    isSupportedBrowser() {
        if ( this.audioContext === undefined ) return false;
        if ( navigator.mediaDevices === undefined || navigator.mediaDevices.getDisplayMedia === undefined ) return false;
        if ( typeof MediaRecorder === undefined ) return false;
        
        return true;
    }
}

export class ServerRecord {
    constructor(props) {
        this.props = props;

        this.record = null;
        this.websockt = null;
        this.userID = null;

        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.save = this.save.bind(this);
    }

    setRecord() {
        this.record = new ScreenRecord();

        const handler = {
            start: this.start,
            stop: this.stop,
            save: this.save
        };

        this.record.init(handler);

        if (!this.record.isSupportedBrowser()) return false;
        
        return true;
    }

    startRecord(audioTracks) {
        this.record.loadAudioStraem(audioTracks);
        this.record.startRecord();
    }

    async start() {
        console.log("start");
        await this._createWebSocket();

        const access_token = APP.mateManagement.getAccessToken();
        const response = await this._request("SetAuth", { access_token }, null, 5000);

        if (response.status != 200) {
            // throw new Error(util.formatMessage(response.payload.message));
        }
        this.userID = response.payload.result.user.user_id;

        const option = APP.store.getState()['features/recording'][RECORDING_TYPE.SERVER].option;
        const result = await this._request("UseResource", option, null, 5000);
        
        if (response.status !== 200) {
            // throw new Error(util.formatMessage(response.payload.message));
        }
    }

    async save(binary) {
        // console.log("save", binary);
        // "AppendResource"
        const option = APP.store.getState()['features/recording'][RECORDING_TYPE.SERVER].option;
        const response = await this._request("AppendResource", option, binary, 5000);
        if (response.status != 200) {
            // throw new Error(util.formatMessage(response.payload.message));
            return;
        }        
        // response.payload;        
    }

    stop() {
        this.record.stopRecord();

        this.props.setRecordParticipant(false, RECORDING_TYPE.SERVER);
    }

    _cleanup() {
        if (!!this.websocket) {
            this.props.setRecordParticipant(false);

            this.websocket.close();
        }
        this.websocket = null;
    }
    
    _createWebSocket() {
        if (!!this.websocket) {
            throw new Error("이미 접속중입니다.");
        }

        this.nextId = 1;
        this.onDisconnected = [];
        this.onMessage = [];
        this.userID = null;
        return new Promise((resolve, reject) => {
            const ws = new WebSocket(`wss://${location.host}/api/recording/v1/websocket`);
                        
            ws.onopen = () => {
                ws.onclose = () => {
                    this.onDisconnected.forEach((handle) => {
                        handle();
                    });
                    
                    this._cleanup();
                };
                
                ws.onmessage = (msg) => {
                    this._handleMessage(msg.data);
                    this.onMessage.forEach((handle) => {
                        handle(msg.data);
                    });
                };
                
                this.props.setRecordParticipant(true);

                this.websocket = ws;
                // setTimeout(() => {
                //     this._cleanup();
                // }, 5000);
                return resolve();
            };
            
            ws.onerror = (err) => {
                this._cleanup();
                return reject(err);
            };
        });
    }

    _subscribe(handle) {
        this.onMessage.push(handle);
        
        return () => {
            const index = this.onMessage.findIndex((element) => {
                return element == handle;
            });
            
            if (index >= 0) {
                this.onMessage.splice(index, 1);
            }
        };
    }
    
    _subscribeDisconnection(handle) {
        this.onDisconnected.push(handle);
        
        return () => {
            const index = this.onDisconnected.findIndex((element) => {
                return element == handle;
            });
            
            if (index >= 0) {
                this.onDisconnected.splice(index, 1);
            }
        };
    }

    async _request(clazz, payload, binary, timeout) {
        if (!this.websocket || this.websocket.readyState !== WebSocket.OPEN) {
            this.props.setRecordParticipant(false, RECORDING_TYPE.SERVER);
            // throw new Error("요청할 수 있는 상태가 아닙니다.");
            return;
        }
        
        const ws = this.websocket;
        const requestID = `${Date.now()}-${++this.nextId}`;
        if (binary) {
            ws.send (
                new Blob([ new TextEncoder().encode(
                    JSON.stringify({ class: clazz, id: requestID, payload: payload })
                ), new Uint8Array([0]), binary ])
            );
        } else {
            ws.send( 
                JSON.stringify({ class: clazz, id: requestID, payload: payload }) 
            );
        }

        return this._waitFor((data) => JSON.parse(data), (res) => res.id === requestID, timeout);
    }

    async _waitFor(hook, check, timeout) {
        return new Promise((resolve, reject) => {
            let timerID;
            let unsubcribe;
            
            const cleanup = () => {
                clearTimeout(timerID);
                unsubcribe();
            };

            unsubcribe = this._subscribe((data) => {
                try {
                    const result = hook(data);
                    
                    if (!check(result)) return;
              
                    cleanup();
                    return resolve(result);
                } catch (err) {
                    cleanup();
                    return reject(err);
                }
            });
            
            timerID = setTimeout(() => {
                cleanup();
                return reject();
            }, timeout);
        });
    } 
    
    _handleMessage(data) {}
}

export class PersonalRecord {
    constructor(props) {
        this.props = props;

        this.record = null;
        this.websockt = null;

        this.start = this.start.bind(this);
        this.stop = this.stop.bind(this);
        this.save = this.save.bind(this);
    }

    setRecord() {
        this.record = new ScreenRecord();

        const handler = {
            start: this.start,
            stop: this.stop,
            save: this.save
        };

        this.record.init(handler);

        if (!this.record.isSupportedBrowser()) return false;
        
        return true;
    }

    connectAudio(tracks) {
        this.record.connectAudio(tracks);
    }

    startRecord(audioTracks) {
        this.record.loadAudioStraem(audioTracks);
        this.record.startRecord();
    }

    start() {
        this.props.setRecordParticipant(true);
    }

    save() {
        // console.log("save");        
    }

    stop() {
        // console.log("stop");
        this.record.stopRecord();
        
        const filename = this.getFileName();
        this.record.getSaveFile(filename);

        this.props.setRecordParticipant(false, RECORDING_TYPE.PERSONAL);
    }

    getFileName() {
        const now = new Date();
        const timestamp = now.toISOString();
        const room = decodeURIComponent(getRoomOption(APP.store.getState()).name);
        if (room)
            return `${room}_${timestamp}`;
        else
            return `recording_${timestamp}`;
    }
}